const initWelcomeMessageSidebar = () => {
  const selectors = {
    open: '[data-welcome-sidebar-open]',
    close: '[data-welcome-sidebar-close]',
    panel: '[data-welcome-sidebar-id]',
  }

  const panels = Array.from(document.querySelectorAll(selectors.panel))

  if (!panels.length || document.body.dataset.welcomeSidebarInitialized === 'true') return

  const showPanel = (panel) => {
    document.querySelectorAll('.welcome-message-sidebar--open').forEach((activePanel) => {
      activePanel.classList.add('hidden')
      activePanel.classList.remove('welcome-message-sidebar--open')
      activePanel.setAttribute('aria-hidden', 'true')
    })

    panel.classList.remove('hidden')
    panel.setAttribute('aria-hidden', 'false')

    requestAnimationFrame(() => {
      panel.classList.add('welcome-message-sidebar--open')
      document.body.classList.add('overflow-hidden')
      document.body.classList.add('welcome-sidebar-open')
    })
  }

  const hidePanel = (panel) => {
    panel.classList.remove('welcome-message-sidebar--open')
    panel.setAttribute('aria-hidden', 'true')

    const completeClose = () => {
      panel.classList.add('hidden')
      if (!document.querySelector('.welcome-message-sidebar--open')) {
        document.body.classList.remove('overflow-hidden')
        document.body.classList.remove('welcome-sidebar-open')
      }
    }

    const timeout = setTimeout(completeClose, 260)

    panel.addEventListener(
      'transitionend',
      () => {
        clearTimeout(timeout)
        completeClose()
      },
      { once: true }
    )
  }

  const findPanel = (id) => document.querySelector(`[data-welcome-sidebar-id="${id}"]`)

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest(selectors.open)
    if (openTrigger) {
      const panel = findPanel(openTrigger.getAttribute('data-welcome-sidebar-open'))
      if (panel) showPanel(panel)
      return
    }

    const closeTrigger = event.target.closest(selectors.close)
    if (closeTrigger) {
      const panel = findPanel(closeTrigger.getAttribute('data-welcome-sidebar-close'))
      if (panel) hidePanel(panel)
    }
  })

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return

    const activePanel = document.querySelector('.welcome-message-sidebar--open')
    if (activePanel) hidePanel(activePanel)
  })

  document.body.dataset.welcomeSidebarInitialized = 'true'
}

export default initWelcomeMessageSidebar
